/**
 * Organización de los proyectos (doc. 03 §3.1, paso 1.5): espacios de trabajo por cliente y
 * carpetas. Es organización lógica dentro del navegador, **no** aislamiento de seguridad entre
 * clientes: la versión 1 no es multiusuario.
 */

/** Versión del esquema de los documentos de organización (espacio de trabajo y carpeta). */
export const VERSION_ESQUEMA_ORGANIZACION = 1;

/** El espacio de trabajo que siempre existe y no se puede eliminar. */
export const ESPACIO_DE_TRABAJO_PROPIO = 'propio';

export type TipoEspacioDeTrabajo = 'propio' | 'cliente';

export interface EspacioDeTrabajo {
  versionEsquema: number;
  id: string;
  nombre: string;
  tipo: TipoEspacioDeTrabajo;
  /**
   * «Privado · contiene datos reales»: insignia visible, la exportación pide confirmación y el
   * archivo lo declara; sus proyectos no salen a un espacio de trabajo sin la marca, no se
   * convierten en plantilla ni aparecen en el modo demo (fase 1B).
   */
  contieneDatosReales: boolean;
  creadoEn: string;
  actualizadoEn: string;
}

export interface Carpeta {
  versionEsquema: number;
  id: string;
  espacioDeTrabajoId: string;
  nombre: string;
  color: string;
  creadoEn: string;
}

/** Colores de carpeta (los del v6, legibles sobre la paleta A). */
export const COLORES_DE_CARPETA = [
  '#4FC3CC',
  '#8CCB5E',
  '#F4D03F',
  '#9B7BD4',
  '#F2675A',
  '#93A3AC',
] as const;

export function espacioDeTrabajoPropio(ahora: string): EspacioDeTrabajo {
  return {
    versionEsquema: VERSION_ESQUEMA_ORGANIZACION,
    id: ESPACIO_DE_TRABAJO_PROPIO,
    nombre: 'Mis proyectos',
    tipo: 'propio',
    contieneDatosReales: false,
    creadoEn: ahora,
    actualizadoEn: ahora,
  };
}

export type ResultadoRegla = { ok: true } | { ok: false; motivo: 'datos-reales' };

/**
 * Regla de integridad 7 (doc. 03 §4): lo que viene de un espacio de trabajo con datos reales no
 * pasa a uno sin la marca (mover un proyecto o importar un archivo marcado).
 */
export function puedeLlevarse(
  conDatosReales: boolean,
  destino: Pick<EspacioDeTrabajo, 'contieneDatosReales'>,
): ResultadoRegla {
  return conDatosReales && !destino.contieneDatosReales
    ? { ok: false, motivo: 'datos-reales' }
    : { ok: true };
}
